"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorObjectPositionCalculatorBase = void 0;
var AnchorObjectPositionCalculatorBase = (function () {
    function AnchorObjectPositionCalculatorBase(manager) {
        this.manager = manager;
    }
    Object.defineProperty(AnchorObjectPositionCalculatorBase.prototype, "anchorInfo", {
        get: function () {
            return this.obj.anchorInfo;
        },
        enumerable: false,
        configurable: true
    });
    AnchorObjectPositionCalculatorBase.prototype.init = function (obj) {
        this.lp = this.manager.activeFormatter.layoutPosition;
        this.obj = obj;
        this.isRelativeCell = !!this.manager.activeFormatter.tableFormatter &&
            (obj.anchorInfo.layoutTableCell || this.manager.model.compatibilitySettings.layoutInTableCell);
    };
    return AnchorObjectPositionCalculatorBase;
}());
exports.AnchorObjectPositionCalculatorBase = AnchorObjectPositionCalculatorBase;
